import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ModalController } from '@ionic/angular';

export interface ProductDetail {
  id: string;
  name: string;
  description: string;
  price: number;
  currency: string;
  image?: string;
  ingredients: string;
  nutritionalInfo: NutritionalInfo;
  allergenInfo?: string;
}

export interface NutritionalInfo {
  energie: string;
  kalorien: string;
  fett: string;
  fettsäuren: string;
  kohlenhydrate: string;
  zucker: string;
  eiweiß: string;
  salz: string;
}

@Component({
  selector: 'app-product-detail-modal',
  templateUrl: './product-detail-modal.component.html',
  styleUrls: ['./product-detail-modal.component.scss']
})
export class ProductDetailModalComponent implements OnInit {
  @Input() product: ProductDetail;
  @Output() closeModal = new EventEmitter<void>();

  // Sample data matching the screenshot
  defaultProduct: ProductDetail = {
    id: 'placeholder-1',
    name: 'Platzhalter',
    description: '',
    price: 13.50,
    currency: 'CHF',
    ingredients: 'Filtered drinking water (37.38%), peas* (29.85%), onion* (9.35%), carrot* (7.43%), leek* (4.37%), Dijon mustard* (3.98%) (water, brown MUSTARD SEED* brandy vinegar*, sea salt; medium hot), apple cider vinegar* (2.49%) (apple juice*), CELERY* (1.46%), mint* (1.19%), sea salt (1.19%), olive oil* (0.60%), garlic* (0.36%), tomato paste* (0.15%) (tomatoes*), raw cane sugar* (0.13%), juniper berries* (0.07%), bay leaf* (0.01%). *From organically controlled cultivation.',
    nutritionalInfo: {
      energie: '283 kJ/ 283 kJ',
      kalorien: '658 kcal/ 658 kcal',
      fett: '62,5 g/ 62,5 g',
      fettsäuren: '6,8 g/ 6,8 g',
      kohlenhydrate: '10,6 g/ 10,6 g',
      zucker: '7 g/ 7 g',
      eiweiß: '17 g/ 17 g',
      salz: '< 0,1 g/ < 0,1 g'
    },
    allergenInfo: '*Wenn Sie weitere Informationen zu den Allergenen benötigen, fragen Sie bitte unser Personal nach der Liste und den Angaben dazu.'
  };

  constructor(private modalController: ModalController) {}

  ngOnInit() {
    // Use provided product or default
    if (!this.product) {
      this.product = this.defaultProduct;
    }
  }

  async onClose() {
    this.closeModal.emit();
    await this.modalController.dismiss();
  }

  // Helper method to format nutritional info
  getNutritionalEntries(): Array<{label: string, value: string}> {
    return [
      { label: 'Energie', value: this.product.nutritionalInfo.energie },
      { label: 'Kalorien', value: this.product.nutritionalInfo.kalorien },
      { label: 'Fett davon gesättigte', value: this.product.nutritionalInfo.fett },
      { label: 'Fettsäuren', value: this.product.nutritionalInfo.fettsäuren },
      { label: 'Kohlenhydrate', value: this.product.nutritionalInfo.kohlenhydrate },
      { label: 'Zucker', value: this.product.nutritionalInfo.zucker },
      { label: 'Eiweiß', value: this.product.nutritionalInfo.eiweiß },
      { label: 'Salz', value: this.product.nutritionalInfo.salz }
    ];
  }
}